// extracted by mini-css-extract-plugin
export default {"OnlineStudyPlannerSection":"W1zuL6KqEhA_QztP2y7H","Header":"GmPkVDdUBvO0d_LpMlQn","Heading":"EdHYHcI0ptkQLSAXMolJ","Teaser":"gw4MctdzJTKcZ3Uew3lC"};